import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import Switch from "@mui/material/Switch";
import { Field } from "react-final-form";

interface OptionProps {
  input: {
    value: any;
    [key: string]: any;
  };
  meta: any;
  label?: string;
  [key: string]: any;
}

const Option = (props: OptionProps) => {
  const {
    input: { value, ...restInput },
    label,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    meta,
    ...rest
  } = props;

  return (
    <FormControlLabel
      control={<Switch value={String(value)} />}
      label={label}
      {...restInput}
      {...rest}
    />
  );
};

interface SwitchOption {
  value: string | number;
  label: string;
}

interface SwitchGroupProps {
  label?: string;
  helperText?: string;
  options?: SwitchOption[];
  name: string;
}

export function SwitchGroup({
  label,
  helperText,
  options = [],
  name,
}: SwitchGroupProps) {
  return (
    <FormControl component="fieldset">
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup>
        {options.map((option) => (
          <Field
            name={name}
            type="checkbox"
            value={option.value}
            label={option.label}
            component={Option}
            key={option.value}
          />
        ))}
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
